import { callWithAuth } from '@/services/auth/call-with-auth'

async function main() {
  await callWithAuth(() => {
    // templates/Referral/Start/ReferralStart/default.php
    document.forms['user-referral-start-form'].submit()
  })
}

main()
